import { RouteObject } from "react-router";

import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const competencyRoutes: RouteObject = {
	path: "competency/*",
	children: [
		{
			path: "user/*",
			lazy: async () => {
				const { UserCompetency } = await import("./pages/UserCompetency");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<UserCompetency />
						</Sentry.ErrorBoundary>
					),
				};
			},
			children: [
				{
					path: ":userid",
					lazy: async () => {
						const { UserCompetency } = await import("./pages/UserCompetency");
						return { Component: UserCompetency };
					},
				},
			],
		},
		{
			path: "resource/*",
			children: [
				{
					path: "new",
					lazy: async () => {
						const { NewCompetencyResource } =
							await import("./pages/CompetencyResource");
						return { Component: NewCompetencyResource };
					},
				},
				{
					path: ":id/edit",
					lazy: async () => {
						const { EditCompetencyResource } =
							await import("./pages/CompetencyResource");
						return { Component: EditCompetencyResource };
					},
				},
				{
					path: ":id/delete",
					lazy: async () => {
						const { DeleteCompetencyResource } =
							await import("./pages/CompetencyResource");
						return { Component: DeleteCompetencyResource };
					},
				},
			],
		},
		{
			path: "matrix/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { ShowCompetenceMatrix } =
							await import("./pages/ShowCompetenceMatrix");
						return { Component: ShowCompetenceMatrix };
					},
				},
				{
					path: ":id",
					lazy: async () => {
						const { ShowCompetenceMatrix } =
							await import("./pages/ShowCompetenceMatrix");
						return { Component: ShowCompetenceMatrix };
					},
				},
			],
		},
		{
			path: "create/:id/user/:userid",
			lazy: async () => {
				const { CreateCompetency } = await import("./pages/CreateCompetency");
				return { Component: CreateCompetency };
			},
		},
		{
			path: "checkoff/:id",
			lazy: async () => {
				const { CompetencyCheckoff } =
					await import("./pages/CompetencyCheckoff");
				return { Component: CompetencyCheckoff };
			},
		},
	],
};
